import React, {useState, useEffect, useRef} from "react";
import {DEFAULT_BLUE} from "../../../constants/general-constants";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {functions} from "../../../constants/common-functions";
import {STRINGIFY} from "../../../constants/general-constants";

export default function ClientCommercialContactPanel({id, clientCommercialContact, reloadFunction}){
	
	const [displayEdit, setDisplayEdit] = useState("none");
	const [displayView, setDisplayView] = useState("flex");
	const [thisName, setThisName] = useState("");
	
	const refName = useRef(null);
	const refRole = useRef(null);
	const refPhone = useRef(null);
	const refEmail = useRef(null);
	const refLocation = useRef(null);
	const refComments = useRef(null);
	const refShowOnContacts = useRef(null);
	const refEmailPhotos = useRef(null);
	
	useEffect(() => {
		
		setThisName(clientCommercialContact.name);
		if(id === -100){
			setDisplayEdit("flex");
			setDisplayView("none");
			refName.current.value = "";
			refRole.current.value = "";
			refEmail.current.value = "";
			refPhone.current.value = "";
			refLocation.current.value = "";
			refComments.current.value = "";
			refShowOnContacts.current.value = "-100";
			refEmailPhotos.current.value = "-100";
		}
		else{
			refName.current.value = clientCommercialContact.name;
			refRole.current.value = clientCommercialContact.role;
			refEmail.current.value = clientCommercialContact.email;
			refPhone.current.value = clientCommercialContact.phone;
			refLocation.current.value = clientCommercialContact.location;
			refComments.current.value = clientCommercialContact.comments;
			if(clientCommercialContact.showOnContacts === true){
				refShowOnContacts.current.value = "Y";
			}
			else{
				refShowOnContacts.current.value = "N";
			}
			if(clientCommercialContact.emailPhotos === true){
				refEmailPhotos.current.value = "Y";
			}
			else{
				refEmailPhotos.current.value = "N";
			}
		}
	}, [clientCommercialContact, id]);
	
	const thisContainer = {
		display:"flex",
		width:"100%",
		backgroundColor:"#eee",
		borderRadius:"4px",
		minHeight:"40px",
		marginTop:"10px"
	};
	
	const blueButton = {
		display:"flex",
		width:"100px",
		height:"30px",
		alignItems:"center",
		color:"white",
		backgroundColor:DEFAULT_BLUE,
		cursor:"pointer",
		justifyContent:"space-around",
		borderRadius:"4px",
		fontSize:"12px",
		margin:"5px"
	};
	
	const editPanel = {
		display:displayEdit,
		width:"100%",
		flexDirection:"column",
		paddingTop:"10px",
		paddingBottom:"10px"
	};
	
	const viewPanel = {
		display:displayView,
		width:"100%",
		alignItems:"center",
		justifyContent:"space-between"
	};
	
	const editRow = {
		display:"flex",
		width:'100%',
		height:"30px",
		alignItems:"center"
	};
	
	const editLabel = {
		display:'flex',
		paddingLeft:"10px",
		fontSize:"12px",
		color:"black",
		width:"200px",
	};
	
	const textInput = {
		display:"flex",
		width:"200px",
		height:"20px",
		paddingLeft:"10px",
		fontSize:"12px",
		color:"black",
		border:"1px solid #999",
		backgroundColor:"rgba(0,0,0,0)"
	};
	
	const buttonBar = {
		display:"flex",
		alignSelf:"center",
		marginTop:"10px"
	};
	
	const getSubmitObject = () => {
		let showOnContacts = false;
		let emailPhotos = false;
		
		if(refShowOnContacts.current.value === "Y"){
			showOnContacts = true;
		}
		
		if(refEmailPhotos.current.value === "Y"){
			emailPhotos = true;
		}
		
		let submitObject = {
			id:id,
			name:refName.current.value,
			role:refRole.current.value,
			email:refEmail.current.value,
			phone:refPhone.current.value,
			location:refLocation.current.value,
			comments:refComments.current.value,
			showOnContacts:showOnContacts,
			emailPhotos:emailPhotos
		};
		console.log("SUBMIT IBJECT");
		console.log(submitObject);
		return submitObject;
	};
	
	const goSubmit = () => {
		setThisName(refName.current.value);
		functions.submitAjax("/resolution/clientcommercialcontactsave", 
				getSubmitObject(), closeEdit,  STRINGIFY, handleSubmitError);
		closeEdit();
	};
	
	const goDelete = () => {
		functions.submitAjax("/resolution/clientcommercialcontactdelete", 
				getSubmitObject(), closeEdit,  STRINGIFY, handleSubmitError);
		
	};
	
	const handleSubmitError = (e) => {
		closeEdit();
	};
	
	const closeEdit = () => {
		setDisplayEdit("none");
		setDisplayView("flex");
		reloadFunction();
	};
	
	const goEdit = () => {
		setDisplayEdit("flex");
		setDisplayView("none");
	};
	
	return (
		<div style={thisContainer}>	
			<div style={viewPanel}>
				<div style={editLabel}>
						{thisName}
				</div>
				<div style={blueButton} onClick={goEdit}>
						Edit
				</div>
			</div>
			<div style={editPanel}>
				<div style={editRow}>
					<div style={editLabel}>
						Name
					</div>
					<input style={textInput} type="text" ref={refName}/>
				</div>
				<div style={editRow}>
					<div style={editLabel}>
						Role
					</div>
					<input style={textInput} type="text" ref={refRole}/>
				</div>
				<div style={editRow}>
					<div style={editLabel}>
						Email
					</div>
					<input style={textInput} type="text" ref={refEmail}/>
				</div>
				<div style={editRow}>
					<div style={editLabel}>
						Phone
					</div>
					<input style={textInput} type="text" ref={refPhone}/>
				</div>
				<div style={editRow}>
					<div style={editLabel}>
						Location
					</div>
					<input style={textInput} type="text" ref={refLocation}/>
				</div>
				<div style={editRow}>
					<div style={editLabel}>
						Comments
					</div>
					<input style={textInput} type="text" ref={refComments}/>
				</div>
				<div style={editRow}>
					<div style={editLabel}>
						Show On Contacts
					</div>
					<select style={textInput} ref={refShowOnContacts}>
						<option value="-100">Select</option>
						<option value="Y">Yes</option>
						<option value="N">No</option>
					</select>
				</div>
				<div style={editRow}>
					<div style={editLabel}>
						Email Photos
					</div>
					<select style={textInput} ref={refEmailPhotos}>
						<option value="-100">Select</option>
						<option value="Y">Yes</option>
						<option value="N">No</option>
					</select>
				</div>
				<div style={buttonBar}>
					<div style={blueButton} onClick={goSubmit}>
						Save
					</div>
					<div style={blueButton} onClick={goDelete}>
						Delete
					</div>
					<div style={blueButton} onClick={closeEdit}>
						Cancel
					</div>
				</div>
			</div>
		</div>
		
	);
}